import React, { useReducer } from 'react';

import { AccountsContext } from './AccountsContext';
import { AccountsContextProviderProps } from './AccountsContext.types';
import {
  accountsReducer,
  ADD_ACCOUNT,
  REMOVE_ACCOUNT,
  RESET_ACTIVE_ACCOUNT,
  SET_ACTIVE_ACCOUNT,
  UPDATE_ACCOUNT,
} from './reducer/accountsReducer';

export const AccountsContextProvider = ({ accounts: accountsInit, children }: AccountsContextProviderProps) => {
  const [state, dispatch] = useReducer(accountsReducer, { accounts: accountsInit });

  return (
    <AccountsContext.Provider
      value={{
        accounts: state.accounts,
        activeAccount: state.activeAccount,
        addAccount: account => dispatch({ type: ADD_ACCOUNT, account }),
        removeAccount: uuid => dispatch({ type: REMOVE_ACCOUNT, uuid }),
        resetActiveAccount: () => dispatch({ type: RESET_ACTIVE_ACCOUNT }),
        setActiveAccount: uuid => dispatch({ type: SET_ACTIVE_ACCOUNT, uuid }),
        updateAccount: account => dispatch({ type: UPDATE_ACCOUNT, account }),
      }}
    >
      {children}
    </AccountsContext.Provider>
  );
};
